import axios from "axios";

export async function getTranslations(lang) {
    return await axios.get(`/lang/${lang}.json`)
        .then(res =>res.data);
}

